<div id="contentColorbook" class="contentHeight">
    <button id="backBoutonColorWin" class="backColorWin" (click)="previousColorWin()" *ngIf="canBackColorbookBalance">
        <i aria-hidden="true" class="fas fa-arrow-left color-white fa-2x"></i>
    </button>
    <vehicle (modelOutput)="selectModel($event)" [model]="model" [manufacturer]="manufacturer" (manufacturerOut)="changeManufacturer($event)" (statsLog)="statsLog($event)" *ngIf="model==null"></vehicle>
    <bodyShade [model]="model" [manufacturer]="manufacturer" *ngIf="model!=null"></bodyShade>
</div>
